import { render, staticRenderFns } from "./ServerDescription.vue?vue&type=template&id=f8400a7e&scoped=true&lang=pug&"
import script from "./ServerDescription.vue?vue&type=script&lang=js&"
export * from "./ServerDescription.vue?vue&type=script&lang=js&"
import style0 from "./ServerDescription.vue?vue&type=style&index=0&id=f8400a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8400a7e",
  null
  
)

export default component.exports